import { render } from "./ContainerTripsTable.vue?vue&type=template&id=bf79099e&scoped=true&ts=true"
import script from "./ContainerTripsTable.vue?vue&type=script&lang=ts"
export * from "./ContainerTripsTable.vue?vue&type=script&lang=ts"

import "./ContainerTripsTable.vue?vue&type=style&index=0&id=bf79099e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf79099e"]])

export default __exports__